/**分析部分公共方法：数据处理公用部分 */
// 引入公共方法
import { defaultOptions, toFixed } from "@/plugins/index.js";

/* 负载分析图1 */
export const electricOverview = (dayElec = [], meanElec) => {
	let x_data = [],
		y_data = [];
	dayElec.map(el => {
		x_data.push(el.time);
		y_data.push(toFixed(el.value, 2));
	});
	let option = {
		...JSON.parse(JSON.stringify(defaultOptions)),
	};
	option.xAxis.data = x_data;
	option.series = [
		{
			name: "电量",
			data: y_data,
			type: "bar",
		},
		{
			name: "日平均电量",
			data: Array(x_data.length).fill(toFixed(meanElec, 2)),
			type: "line",
			symbol: "none", // 去除圆点
		},
	];
	option.color = ["#2992f7", "#10af77"];
	option.yAxis.name = "电量/kWh";
	option.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			let str = "";
			if (params.length > 0) {
				str = `<span style='font-weight:600'>${seriesData1.name}</span>`;
			}
			params.map(param => {
				str += ` <br> ${param.marker} ${param.seriesName}：${param.data} kWh`;
			});

			return str;
		},
	};
	// 渲染图表
	console.log(option);
	return option;
};

/*负载分析图2 */
export const typicalDayOption = (typicalDayCurves = [], tfmCapacity = 0) => {
	let x_data = [];
	let series = [];
	let colors = ["#09BA76", "#0082FA", "#5470c6"];
	typicalDayCurves.map((el, index) => {
		let obj = {
			name: `${el.name}`,
			data: [],
			type: "line",
			symbol: "none", // 去除圆点
			// lineStyle: {
			// 	color: colors[index] // 设置折线的颜色
			// }
		};
		el.curve.map(cl => {
			// 取第一项的时间作为x轴
			if (index === 0) {
				let arr = cl.time.split(":")
				arr.pop()
				x_data.push(arr.join(':'));
			}
			obj.data.push(toFixed(cl.value, 2));
		});
		series.push(obj);
	});
	let option = {
		...JSON.parse(JSON.stringify(defaultOptions)),
	};
	colors.push("#F30D0F");
	option.color = colors;
	option.xAxis.data = x_data;
	option.series = [
		...series,
		{
			name: "变压器容量",
			data: Array(x_data.length).fill(toFixed(tfmCapacity, 2)),
			type: "line",
			symbol: "none", // 去除圆点
			lineStyle: {
				type: "dashed", // 设置虚线样式
				// color: "#F30D0F"
			},
			unit: "kVA",
		},
	];
	option.yAxis.name = "功率/kW";
	option.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			let str = `<span style='font-weight:600'>${seriesData1.name}</span>`;
			params.map(el => {
				str += ` <br> ${el.marker} ${el.seriesName}：${el.data} ${el.seriesName == "变压器容量" ? "kVA" : "kW"
					} `;
			});
			return str;
		},
	};
	return option;
};

/*配储评估图1：处理日均收益跟单位容量日均收益数据 */
export const processingData = (list = [], title = "", decimals = 2) => {
	let series = [
		{
			name: "智能策略",
			data: [],
			type: "bar",
			barWidth: 12, // 设置柱状图的宽度
		},
		{
			name: "固定策略",
			data: [],
			type: "bar",
			barWidth: 12, // 设置柱状图的宽度
		},
	];
	let resultOptions = {
		...JSON.parse(JSON.stringify(defaultOptions)),
	};

	let x_data = [];
	list.map(el => {
		x_data.push(el.capacity);
		series[0].data.push(toFixed(el.wise, decimals));
		series[1].data.push(toFixed(el.prev, decimals));
	});

	// 数据处理
	// resultOptions.xAxis.data = x_data;
	resultOptions.xAxis = {
		type: "category",
		name: "储能装机容量(kWh)",
		axisTick: {
			show: false,
		},
		data: x_data,
		nameTextStyle: {

			verticalAlign: "top",
			fontSize: 14,
			padding: [25, 0, 0, -120]
		},
	};
	resultOptions.grid.bottom = '10%'
	resultOptions.yAxis.name = title;
	resultOptions.yAxis.nameLocation = "end";
	resultOptions.series = series;
	resultOptions.color = ["#0082FC", "#0BBA74"];
	resultOptions.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			let str = ``;
			if (params.length > 0) {
				str = `<span style='font-weight:600'>储能装机容量：${seriesData1.name}kWh</span>`;
			}
			params.map(params => {
				str += `<br> ${params.marker}${params.seriesName}：${params.data} ${title} `;
			});
			return str;
		},
	};
	return resultOptions;
};

// 配储评估：电量电费对比
export const mackElecOptios = (data, title, type = "") => {
	let x_data = ["尖电", "峰电", "平电", "谷电", "深谷"];
	const { sharp, peak, flat, valley, ravine } = data;
	let step = 1;
	let decimals = 2;
	if (title === "MWh") {
		step = 1000;
	}
	if (title === "万元") {
		step = 10000;
		decimals = 4;
	}

	let elecOption = {
		...JSON.parse(JSON.stringify(defaultOptions)),
		series: [
			{
				name: "配储前",
				data: [
					sharp ? toFixed(sharp.before / step, decimals) : "-",
					peak ? toFixed(peak.before / step, decimals) : "-",
					flat ? toFixed(flat.before / step, decimals) : "-",
					valley ? toFixed(valley.before / step, decimals) : "-",
					ravine ? toFixed(ravine.before / step, decimals) : "-",
				],
				type: "bar",
				barWidth: type == 'h5' ? 6 : 16, // 设置柱状图的宽度
			},
			{
				name: "配储后",
				data: [
					sharp ? toFixed(sharp.after / step, decimals) : "-",
					peak ? toFixed(peak.after / step, decimals) : "-",
					flat ? toFixed(flat.after / step, decimals) : "-",
					valley ? toFixed(valley.after / step, decimals) : "-",
					ravine ? toFixed(ravine.after / step, decimals) : "-",
				],
				type: "bar",
				barWidth: type == 'h5' ? 6 : 16, // 设置柱状图的宽度
			},
		],
	};
	elecOption.xAxis.data = x_data;
	elecOption.yAxis.name = title;
	elecOption.color = ["#7C92BA", "#0082FC"];
	elecOption.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			const seriesData2 = params[1];
			let str = `<span style='font-weight:600'>${seriesData1.name}</span>`;
			params.map(el => {
				str += ` <br> ${el.marker} ${el.seriesName}：${el.data} ${title} `;
			});
			return str;
		},
	};
	return elecOption;
};

// 生成汇总数据
export const makeTotalData = (
	lists = [],
	keys = [],
	unsetKeys = [],
	step = 10000
) => {
	let obj = {
		year: undefined,
	};
	if (lists.length > 0) {
		Object.keys(lists[0]).map(key => (obj[key] = 0));
	}
	obj.year = `总计`;

	lists.map(row => {
		keys.map(key => {
			obj[key] += Number(row[key]);
		});
	});
	unsetKeys.map(key => (obj[key] = "/"));

	// 格式化数据
	keys.map(key => {
		obj[key] = toFixed(obj[key] / step);
	});

	return obj;
};
